// W148 · 2026-05-28 · domínio público das superfícies de cliente/comprador.
// Configurável via VITE_VITRINE_PUBLIC_BASE. Default builder.nullscience.ai
// (não usar 'nullscience.ai' cru — usuário final acha que é phishing).
export const VITRINE_PUBLIC_BASE: string =
  (typeof import.meta !== 'undefined' &&
    (import.meta as { env?: { VITE_VITRINE_PUBLIC_BASE?: string } }).env
      ?.VITE_VITRINE_PUBLIC_BASE) ||
  'builder.nullscience.ai';

// W160 · 2026-06-03 · o link público por slug usado até agora era
// `https://${slug}.builder.nullscience.ai` — um sub-domínio wildcard que
// NÃO resolve em DNS (confirmado: "Could not resolve host"). O resultado
// era um link morto compartilhado com compradores (padrão de erro 2: nunca
// gere link que não funciona). A página de marketing real é servida pelo
// app `casa`, que lê o slug por path em `/v/<slug>` no host de marca.
// Default agora aponta para a rota de path no host de marca; o sub-domínio
// por slug fica atrás da flag VITE_VITRINE_USE_SUBDOMAIN para quando o DNS
// wildcard estiver provisionado.
const VITRINE_USE_SUBDOMAIN =
  (typeof import.meta !== 'undefined' &&
    (import.meta as { env?: { VITE_VITRINE_USE_SUBDOMAIN?: string } }).env
      ?.VITE_VITRINE_USE_SUBDOMAIN) === '1';

export function vitrineUrl(slug: string, path?: string): string {
  if (VITRINE_USE_SUBDOMAIN) {
    const base = `https://${slug}.${VITRINE_PUBLIC_BASE}`;
    return path ? `${base}${path}` : base;
  }
  // Rota de path no host de marca (default working).
  const base = `https://${VITRINE_PUBLIC_BASE}/v/${slug}`;
  return path ? `${base}${path}` : base;
}

// W160 · rótulo curto do link público para exibir/copiar na lista de
// vitrines (sem protocolo, mais legível). Acompanha vitrineUrl().
export function vitrineUrlLabel(slug: string): string {
  return VITRINE_USE_SUBDOMAIN
    ? `${slug}.${VITRINE_PUBLIC_BASE}`
    : `${VITRINE_PUBLIC_BASE}/v/${slug}`;
}

// W157 · 2026-06-01 · base de marca para CTAs públicas ("Ir para Builder",
// "Conhecer Builder", wordmark do header). Antes hardcoded como
// 'https://builder.nullscience.ai' / '.builder.app' espalhado por várias
// superfícies públicas (padrão 40 — nunca alias técnico cru). Configurável
// via VITE_BRAND_PUBLIC_BASE, mesmo estilo do VITRINE_PUBLIC_BASE.
export const BRAND_PUBLIC_BASE: string =
  (typeof import.meta !== 'undefined' &&
    (import.meta as { env?: { VITE_BRAND_PUBLIC_BASE?: string } }).env
      ?.VITE_BRAND_PUBLIC_BASE) ||
  'https://builder.nullscience.ai';

export function brandBaseUrl(): string {
  return BRAND_PUBLIC_BASE;
}

// Host (sem protocolo) usado para montar sub-domínios sugeridos no wizard,
// ex: `${slug}.builder.nullscience.ai`. Deriva de brandBaseUrl removendo o
// scheme.
export function brandHost(): string {
  return brandBaseUrl().replace(/^https?:\/\//, '');
}

// W152 · P0-B · 2026-05-29 — link de acesso do interessado aprovado.
// Aponta para a rota pública /ver/:token DO PRÓPRIO APP (não o subdomínio
// brandado do slug — esse caminho exige trabalho no apps/casa e está FLAGGED).
// O PM está logado no SPA quando aprova o lead, então window.location.origin
// é o host que de fato serve /ver/:token. Fallback para o domínio de marca.
export function buyerAccessUrl(rawToken: string): string {
  const origin =
    (typeof window !== 'undefined' && window.location?.origin) ||
    `https://${VITRINE_PUBLIC_BASE}`;
  return `${origin}/ver/${rawToken}`;
}
